import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-audit',
  templateUrl: './user-audit.component.html',
  styleUrls: ['./user-audit.component.css']
})
export class UserAuditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
